import React from 'react';

const BADGE = {
  open:      { label: 'Open',      bg: '#22c55e',    color: '#fff' },
  upcoming:  { label: 'Upcoming',  bg: 'transparent', color: '#555', border: '1px solid #2a2a2a' },
  locked:    { label: 'Locked',    bg: '#f59e0b',    color: '#fff' },
  results:   { label: 'Results',   bg: '#3b82f6',    color: '#fff' },
  cancelled: { label: 'Cancelled', bg: 'transparent', color: '#ef4444', border: '1px solid #3a1a1a' },
};

export default function RaceBadge({ race }) {
  let type = 'upcoming';
  if (race.cancelled)         type = 'cancelled';
  else if (race.official_top10)    type = 'results';
  else if (race.locked)       type = 'locked';
  else if (race.code_required || race.entry_code) type = 'open';

  const { label, bg, color, border } = BADGE[type];
  return (
    <span style={{
      background: bg,
      color,
      border: border || 'none',
      borderRadius: 4,
      padding: '2px 8px',
      fontSize: 12,
      fontWeight: 600,
      letterSpacing: 0.5,
    }}>
      {label}
    </span>
  );
}
